import { render, staticRenderFns } from "./InformationClient.vue?vue&type=template&id=ded31880"
import script from "./InformationClient.vue?vue&type=script&lang=js"
export * from "./InformationClient.vue?vue&type=script&lang=js"
import style0 from "./InformationClient.vue?vue&type=style&index=0&id=ded31880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports